<script setup lang="ts">
import type { AppliedChip } from '@/composables/useAppliedConditions'
import { Close } from '@element-plus/icons-vue'

defineProps<{
  chips: AppliedChip[]
}>()

const emit = defineEmits<{
  clearAll: []
}>()
</script>

<template>
  <div v-if="chips.length"
       class="applied-chips">
    <div class="applied-chips-label">{{ $t('result.applied') }}：</div>
    <ul class="applied-chips-list">
      <li v-for="chip in chips"
          :key="chip.key"
          class="applied-chip">
        <span>{{ chip.label }}</span>
        <el-icon class="cursor-pointer"
                 @click="chip.remove()">
          <Close />
        </el-icon>
      </li>
    </ul>
    <button type="button"
            class="applied-chips-clear"
            @click="emit('clearAll')">
      {{ $t('result.clear_all') }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.applied-chips {
  @apply flex flex-wrap items-center gap-[8px] px-[20px] py-[10px] bg-osn-grey-04;

  .applied-chips-label {
    @apply text-[13px] font-semibold text-osn-dark-grey-00;
  }

  .applied-chips-list {
    @apply flex flex-wrap items-center gap-[6px];

    .applied-chip {
      @apply flex items-center gap-[5px] px-[10px] h-[28px] text-[13px] text-osn-dark-grey-00
      bg-osn-white-00 border border-osn-grey-03 rounded-full;
    }
  }

  .applied-chips-clear {
    @apply ml-auto text-[13px] text-osn-grey-01 underline cursor-pointer;
  }
}
</style>
